import { Record } from 'immutable';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
  availableFonts: [],
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.AVAILABLE_FONTS_REQUEST:
    case types.CREATE_FONT_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.CREATE_FONT_SUCCESS: {
      return state
        .set(constants.ERROR_KEY, false)
        .set(constants.SUCCESS_KEY, true)
        .set(constants.FETCHING_KEY, false)
        .set('availableFonts', [...state.availableFonts, payload]);
    }
    case types.CREATE_FONT_FAILURE:
      return state
        .set(constants.ERROR_KEY, payload?.error || 'Failed to create font')
        .set(constants.SUCCESS_KEY, false)
        .set(constants.FETCHING_KEY, false);
    case types.AVAILABLE_FONTS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, false)
        .set(constants.SUCCESS_KEY, true)
        .set(constants.FETCHING_KEY, false)
        .set('availableFonts', payload);
    case types.AVAILABLE_FONTS_FAILURE:
      return state
        .set(
          constants.ERROR_KEY,
          payload?.error || 'Failed to retrieve font list',
        )
        .set(constants.SUCCESS_KEY, false)
        .set(constants.FETCHING_KEY, false)
        .set('availableFonts', requestReducerState().availableFonts);
    default:
      return state;
  }
};
